  <div *ngIf="safeVideoUrl" class="modal fade" [class.show]="showVideoModal" [style.display]="showVideoModal ? 'block' : 'none'" tabindex="-1" role="dialog" aria-labelledby="videoModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title" id="videoModalLabel">{{title}}</h5>
          <button type="button" class="btn-close btn-close-white" (click)="closeVideoModal()" aria-label="Close"></button>
        </div>
        <div class="modal-body p-0">
          <div class="ratio ratio-16x9">
            <iframe 
              [src]="safeVideoUrl" 
              title="Floor Plan Flyover Video" 
              frameborder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen>
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade" [class.show]="showVideoModal" [style.display]="showVideoModal ? 'block' : 'none'"></div>